import React from 'react';
import { useTranslation } from 'react-i18next';
import './Terms.css';

const Terms = ({ onAccept, onCancel }) => {
  const { t } = useTranslation();
  
  return (
    <>
      <h1 className="terms-title">{t('terms.title')}</h1>
      
      <section className="terms-section">
        <h2>{t('terms.introduction.title')}</h2>
        <p>{t('terms.introduction.content')}</p>
      </section>

      <section className="terms-section">
        <h2>{t('terms.public.title')}</h2>
      </section>
      
      <section className="terms-section">
        <h2>{t('terms.public.introduction.title')}</h2>
        <p>{t('terms.public.introduction.content')}</p>
      </section>
      
      <section className="terms-section">
        <h2>{t('terms.public.interest.title')}</h2>
        <ul>
          <li>{t('terms.public.interest.content1')}</li>
          <li>{t('terms.public.interest.content2')}</li>
        </ul>
      </section>
      
      <section className="terms-section">
        <h2>{t('terms.public.participation.title')}</h2>
        <ul>
          <li>{t('terms.public.participation.content1')}</li>
          <li>{t('terms.public.participation.content2')}</li>
        </ul>
      </section>
      
      <section className="terms-section">
        <h2>{t('terms.public.dataUse.title')}</h2>
        <ul>
          <li>{t('terms.public.dataUse.content1')}</li>
          <li>{t('terms.public.dataUse.content2')}</li>
        </ul>
      </section>
      
      <section className="terms-section">
        <h2>{t('terms.public.disclaimer.title')}</h2>
        <ul>
          <li>{t('terms.public.disclaimer.content1')}</li>
          <li>{t('terms.public.disclaimer.content2')}</li>
        </ul>
      </section>
      
      <section className="terms-section">
        <h2>{t('terms.public.acceptance.title')}</h2>
        <p>{t('terms.public.acceptance.content')}</p>
      </section>
      
      <div className="terms-footer">
        <p>{t('terms.lastUpdate')} {new Date().toLocaleDateString()}</p>
        <div className="terms-buttons">
          <button 
            className="terms-button accept"
            onClick={onAccept}
          >
            {t('terms.buttons.accept')}
          </button>
          <button 
            className="terms-button cancel"
            onClick={onCancel}
          >
            {t('terms.buttons.cancel')}
          </button>
        </div>
      </div>
    </>
  );
};

export default Terms;
